import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `useStaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.dev/gatsby-image
 * - `useStaticQuery`: https://www.gatsbyjs.org/docs/use-static-query/
 */

export const postImage = graphql`
  fragment postImage on ImageSharp {
    id
    fluid {
      ...GatsbyImageSharpFluid
      originalName
      tracedSVG
    }
    fixed(width: 800) {
      originalName
      src
      width
      height
    }
  }
`
export const useImageSharp = src => {
  const fluidData = useStaticQuery(graphql`
    query {
      allImageSharp {
        nodes {
          ...postImage
        }
      }
    }
  `)

  let fluidNode
  for (var i = 0; i < fluidData.allImageSharp.nodes.length; i++) {
    const node = fluidData.allImageSharp.nodes[i]
    if (node.fluid.originalName === src) {
      fluidNode = node.fluid
      return {
        fluid: node.fluid,
        fixed: node.fixed,
      }
    }
  }

  return undefined
}

const Image = ({ src, alt }) => {
  const { fluid } = useImageSharp(src)

  if (!fluid) {
    return null
  }

  return <Img className="rounded shadow" fluid={fluid} alt={alt} />
}

export default Image
